import styled from 'styled-components';

export const StyledContainerFolder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  gap: 16px;
  box-sizing: border-box;
  .skeletonFolders {
    display: flex;
    flex-flow: row wrap;
    gap: 16px 8px;
  }

  .folders {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    max-height: calc(100vh - 316px);
    overflow-y: auto;
    overflow-x: hidden;
    align-content: baseline;

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
      opacity: 0.7;
      border-left: 16px solid transparent;
    }

    &::-webkit-scrollbar {
      width: 12px;
      background-color: #f5f5f5;
      opacity: 0.7;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: rgba(0, 0, 0, 0.2);
      opacity: 0.5;
      border-left: 16px solid transparent;
    }
  }

  @media (max-width: 1024px) {
    .folders {
      max-height: calc(100vh - 282px);
    }

    .skeletonFolders {
      gap: 0.5px;
      padding: 0;
      * {
        width: 100% !important;
      }
    }
  }
`;
